/**
 * Search command handler
 */

import { createSearchService, getApiUrl } from '../utils/client.js';
import { formatOutput, formatPagination, formatSearchTaskTable, isInteractiveOutput } from '../utils/format.js';
import { handleApiError, requireOption } from '../utils/errors.js';

export async function searchTasks(
  query: string,
  token?: string,
  apiUrl?: string,
  options?: {
    project?: number;
    limit?: number;
    json?: boolean;
  }
): Promise<void> {
  try {
    requireOption(query, 'query');

    const service = await createSearchService(token, apiUrl);
    const result = await service.searchTasks({
      query,
      project_id: options?.project,
      limit: options?.limit || 10,
    });

    if (options?.json) {
      console.log(formatOutput(result, true));
    } else {
      if (isInteractiveOutput()) {
        console.log(`\nSearch results for "${query}" (${result.total || 0} total):`);
      }
      if (result.tasks && result.tasks.length > 0) {
        const appBase = new URL(getApiUrl(apiUrl)).origin;
        console.log(formatSearchTaskTable(result.tasks, appBase));

        if (result.has_more && isInteractiveOutput()) {
          console.log('');
          console.log(formatPagination(0, options?.limit || 10, result.total || 0, true));
        }
      } else {
        console.log('  No results found');
      }
    }
  } catch (error) {
    handleApiError(error);
  }
}
